import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getNonLifeInsRoaAndRoeThunk = createAsyncThunk(
  'financialAnalysis/NonLifeIns/GET_ROA_AND_ROE',
  async (data, { rejectWithValue }) => {
    const response = await FinancialAnalysisService.getRoaAndRoe(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadNonLifeInsRoaAndRoeThunk = createAsyncThunk(
  'financialAnalysis/NonLifeIns/DOWNLOAD_ROA_AND_ROE',
  async (data) => {
    const response = await FinancialAnalysisService.downloadRoaAndRoe(data)
    handleExport(response.data, response.filename)
  },
)
